import { Link } from "react-router-dom";
import { MdOutlineRestaurantMenu, MdOutlineAssignment, MdOutlineVisibility } from "react-icons/md";

const Operations = () => {
  const operationsSections = [
    {
      title: "Restaurant Management",
      description: "Manage vendor onboarding, approvals, and account status",
      icon: <MdOutlineRestaurantMenu className="w-8 h-8 text-secondary" />,
      path: "/dashboard/operations/restaurant-management",
      stats: "156 Active Restaurants"
    },
    {
      title: "Order Monitoring",
      description: "Track and manage orders across all vendors in real-time",
      icon: <MdOutlineAssignment className="w-8 h-8 text-secondary" />,
      path: "/dashboard/operations/order-monitoring",
      stats: "45 Active Orders"
    },
    {
      title: "Menu Oversight",
      description: "Review and manage vendor menu items and promotional content",
      icon: <MdOutlineVisibility className="w-8 h-8 text-secondary" />,
      path: "/dashboard/operations/menu-oversight",
      stats: "1,247 Menu Items"
    }
  ];

  return (
    <div className="font-mont">
      <h1 className="font-bold text-2xl mb-2">Operations</h1>
      <p className="text-gray-600 mb-6">Manage restaurant operations and monitor platform activities</p>

      <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {operationsSections.map((section) => (
          <Link
            key={section.title}
            to={section.path}
            className="bg-white p-6 rounded-lg border hover:border-secondary transition-colors duration-200 shadow-sm hover:shadow-md"
          >
            <div className="flex items-start justify-between mb-4">
              <div className="p-3 bg-gray-50 rounded-lg">
                {section.icon}
              </div>
              <span className="text-xs bg-secondary/10 text-secondary px-2 py-1 rounded">
                {section.stats}
              </span>
            </div>
            <h3 className="font-semibold text-lg mb-2">{section.title}</h3>
            <p className="text-sm text-gray-600 mb-4">{section.description}</p>
            <div className="flex items-center text-secondary text-sm font-medium">
              View Details →
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
};

export default Operations;